import axios from 'axios';
import { API_URL } from '../../config/api';
import { Device } from './model';
export type Pending = { kind: 'delete' | 'user'; item: Device } | { kind: 'old' } | { kind: 'bulk'; items: Device[] };
export interface ActionInput { days: number; keep: number }
export async function performAction(pending: Pending, input: ActionInput): Promise<{ message: string; failed?: Device[] }> {
  if (pending.kind === 'bulk') {
    const failed: Device[] = []; let deleted = 0, missing = 0;
    for (let index = 0; index < pending.items.length; index++) {
      const item = pending.items[index];
      if (item.is_active) { failed.push(item); continue; }
      try { await axios.delete(`${API_URL}/admin/devices/${item.id}`); deleted++; }
      catch (error) { if (axios.isAxiosError(error) && error.response?.status === 404) { missing++; continue; } failed.push(item); if (axios.isAxiosError(error) && [401, 403, 429].includes(error.response?.status || 0)) { failed.push(...pending.items.slice(index + 1)); break; } }
    }
    return { message: `${deleted} pasif kayıt silindi.${missing ? ` ${missing} kayıt zaten kaldırılmış.` : ''}`, failed };
  }
  if (pending.kind === 'old') {
    if (!Number.isInteger(input.days) || input.days < 1 || input.days > 90) throw new Error('Invalid inactivity days');
    const { data } = await axios.delete<{deleted_count: number}>(`${API_URL}/admin/devices/cleanup/old`, { params: { days: input.days } });
    return { message: `${data.deleted_count} eski aktif kayıt silindi.` };
  }
  if (pending.kind === 'user') {
    if (!Number.isInteger(input.keep) || input.keep < 1 || input.keep > 10 || !Number.isSafeInteger(pending.item.user_id) || pending.item.user_id <= 0) throw new Error('Invalid retention input');
    const { data } = await axios.delete<{deleted_count: number; remaining_count: number}>(`${API_URL}/admin/devices/user/${pending.item.user_id}/cleanup`, { params: { keep_count: input.keep } });
    return { message: `${data.deleted_count} kayıt silindi; kullanıcıda ${data.remaining_count} kayıt kaldı.` };
  }
  await axios.delete(`${API_URL}/admin/devices/${pending.item.id}`);
  return { message: 'Bildirim kaydı silindi.' };
}
